module.exports = __webpack_public_path__ + "img/hematology.4cee19de.png";